import { Injector } from '@angular/core';

import {
  UIRouter,
  Transition,
  StateObject,
  HookResult,
  TransitionService
} from '@uirouter/angular';

import { ConsumerType, CONSUMERS, CONSUMER_TYPE } from '@tdwb/core';
import { LtiRouterMenuService } from './lti-router-menu.service';
import { LtiRouterStateRedirectingService } from './lti-router-state-redirecting.service';

export class LtiRouterConfigService {

  static routerConfig(uiRouter: UIRouter, injector: Injector): void {
    LtiRouterConfigService.initHooks(uiRouter.transitionService, injector);
  }

  static initHooks(transitionService: TransitionService, injector: Injector): void {
    transitionService.onBefore({ to: 'page.lti.**' }, (transition: Transition): HookResult => {
      const ltiResolveService: LtiRouterStateRedirectingService = transition.injector().get(LtiRouterStateRedirectingService);
      return ltiResolveService.getRedirectStateIfNeeded(transition);
    });

    // TODO Canary for one click flow
    transitionService.onBefore({ from: 'modal.trading.order.equity', to: 'page.lti.**' },
      (transition: Transition): HookResult => {
        const ltiResolveService: LtiRouterStateRedirectingService = transition.injector().get(LtiRouterStateRedirectingService);
        return ltiResolveService.getRedirectStateForOneClickFlow(transition);
      });

    const consumerType: ConsumerType = injector.get<ConsumerType>(CONSUMER_TYPE);
    if (consumerType.consumerId === CONSUMERS.CONSUMER_ID_EASY_TRADE) {
      transitionService.onSuccess({ to: 'page.lti.**' }, LtiRouterConfigService.checkHideFabMenu);
      transitionService.onSuccess(
        { to: (state: StateObject): boolean => !state.name.startsWith('page.lti'),
          from: 'page.lti.**'
        },
        LtiRouterConfigService.checkHideFabMenu);
    }
  }

  static checkHideFabMenu(transition: Transition): void {
    const ltiRouterMenuService: LtiRouterMenuService = transition.injector().get(LtiRouterMenuService);
    ltiRouterMenuService.checkHideFabMenu(transition);
  }
}
